import React from 'react'
import { Typography, Row, Col } from 'antd'
import FOBrokerage from './shared/FOBrokerage'

export default function CurrencyFOBrokrage({ brokers }) {
  const { Title } = Typography

  const charges = brokers.map((broker) => {
    const { consolidated_charges: consolidatedCharges } = broker.attributes
    const flagshipPlan = consolidatedCharges.find(
      (charge) => charge.flagship_plan === true
    )
    return flagshipPlan || consolidatedCharges[0]
  })

  const {
    currency_futures_brokerage: futuresBrokerage1,
    currency_options_brokerage: optionsBrokerage1,
  } = brokers[0].attributes
  const {
    currency_futures_brokerage: futuresBrokerage2,
    currency_options_brokerage: optionsBrokerage2,
  } = brokers[1].attributes

  const textRenderable =
    charges[0]?.currency_futures &&
    charges[0]?.currency_options &&
    charges[1]?.currency_futures &&
    charges[1]?.currency_options

  const tableRenderable =
    futuresBrokerage1 &&
    optionsBrokerage1 &&
    futuresBrokerage2 &&
    optionsBrokerage2

  if (!(textRenderable || tableRenderable)) {
    return null
  }

  return (
    <>
      <Row style={{ marginBottom: '16px' }}>
        <Col span={24}>
          <Title level={2}>
            {`${brokers[0].attributes.name} `}
            vs
            {` ${brokers[1].attributes.name} `}
            Currency Charges and Plans:
            {` ${new Date().getFullYear()}`}
          </Title>
        </Col>
        {textRenderable ? (
          <Col span={24}>
            {` ${brokers[0].attributes.name} `}
            charge
            {` ${charges[0].currency_futures} `}
            for Currency Futures and
            {` ${charges[0].currency_options} `}
            for Currency Options whereas
            {` ${brokers[1].attributes.name} `}
            Charges
            {` ${charges[1].currency_futures} `}
            for Currency futures and
            {` ${charges[1].currency_options} `}
            for Currency options.
          </Col>
        ) : null}
      </Row>

      {tableRenderable ? (
        <FOBrokerage
          brokers={brokers}
          foType="Currency"
          futuresBrokerage1={futuresBrokerage1}
          optionsBrokerage1={optionsBrokerage1}
          futuresBrokerage2={futuresBrokerage2}
          optionsBrokerage2={optionsBrokerage2}
        />
      ) : null}
    </>
  )
}
